import { render, staticRenderFns } from "./StepRegras.vue?vue&type=template&id=a749000a&scoped=true"
import script from "./StepRegras.vue?vue&type=script&lang=js"
export * from "./StepRegras.vue?vue&type=script&lang=js"
import style0 from "./StepRegras.vue?vue&type=style&index=0&id=a749000a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a749000a",
  null
  
)

export default component.exports